module.exports = __webpack_public_path__ + "img/logoMob.03680708.png";